import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import type * as React from 'react';

const tagStyle = css`
	display: inline-flex;
	align-items: center;
	margin-left: 0.5rem;
	padding: 0.125rem 0.5rem;
	border-radius: ${theme.radii.pill};
	background-color: ${theme.aiCosts.superAdminTag.surface};
	color: ${theme.aiCosts.superAdminTag.ink};
	${theme.typography.chip}
	font-size: 0.6875rem;
	letter-spacing: 0.08em;
`;

/** Marks a tab that only a super administrator sees. */
const SuperAdminTag: React.FC = () => {
	return <span css={tagStyle}>SUPER ADMIN</span>;
};

export default SuperAdminTag;
